<template>
  <div
    ref="component"
    class="vt-timeline row"
  >
    <span class="sr-only">{{ srTitleLabel }}</span>
    <div class="col-4 col-md-5">
      <div
        ref="anchored"
        class="anchored decades"
      >
        <span class="sr-only">{{ srDecadesLabel }}</span>
        <a
          v-for="(decade, index) in decades"
          :key="decade.title"
          href="javascript:void(0)"
          class="decade-item decade-item-desktop"
          tabindex="0"
          :class="{ 'active': activeIndex === index }"
          @click="selectDecade(decade)"
          @keyup.enter="selectDecade(decade)"
        >
          {{ decade.label }}
          <span
            v-if="activeIndex === index"
            class="sr-only"
          >{{ srActiveLabel }}</span>
        </a>
      </div>
    </div>
    <div
      ref="timeline"
      class="vt-timeline-container col-7"
    >
      <span class="sr-only">{{ srEventsLabel }}</span>
      <div
        v-for="year in years"
        :id="`year-${year.year}`"
        :ref="`year-${year.year}`"
        :key="year.year"
        class="vt-timeline-item"
      >
        <div class="col-12 vt-timeline-year title vt-timeline-node">
          <p class="year-text">
            {{ year.year }}
          </p>
        </div>
        <div
          v-for="event in year.events"
          :key="event.description"
          class="col-12 vt-timeline-event vt-timeline-node"
        >
          <div class="description">
            {{ event.description }}
          </div>
          <div class="image-container">
            <img
              v-show="event.image"
              class="image lazyload"
              :alt="event.imageAlt"
              :src="`${event.image}?mw=600`"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stickyfill from 'stickyfilljs'

export default {
  name: 'VtTimeline',
  props: {
    decades: {
      type: Array,
      default: () => []
    },
    srTitleLabel: {
      type: String,
      default: 'Timeline',
      required: false
    },
    srDecadesLabel: {
      type: String,
      default: 'Decades',
      required: false
    },
    srActiveLabel: {
      type: String,
      default: 'Active',
      required: false
    },
    srEventsLabel: {
      type: String,
      default: 'Events',
      required: false
    }
  },
  data() {
    return {
      width: 0,
      activeIndex: 0,
      years: []
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 766
    }
  },
  mounted() {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach
    }

    this.decades.forEach(decade => {
      decade.years.forEach(year => {
        this.years.push(year)
      })
    })

    window.addEventListener('scroll', this.onScroll, false)
    window.addEventListener('resize', this.onResize)
    this.onResize()
    this.onScroll()
    Stickyfill.add(this.$refs.anchored)

    this.$refs.timeline.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll, false)
    window.removeEventListener('resize', this.onResize)

    this.$refs.timeline.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    isActiveRange() {
      const container = this.$refs.timeline
      const containerRect = container.getBoundingClientRect()
      const containerTop = containerRect.top
      const containerBottom = containerRect.bottom

      let activeDecadeIndex = null
      let closestDistance = Infinity

      this.years.forEach((year) => {
        const ref = `year-${year.year}`
        const yearElement = this.$refs[ref]?.[0]

        if (yearElement) {
          const yearRect = yearElement.getBoundingClientRect()
          const yearTop = yearRect.top
          const yearBottom = yearRect.bottom

          if (yearBottom > containerTop && yearTop < containerBottom) {
            const yearCenter = yearTop + (yearElement.clientHeight / 2)
            const containerCenter = containerTop + (container.clientHeight / 2)
            const distance = Math.abs(yearCenter - containerCenter)

            if (distance < closestDistance) {
              closestDistance = distance
              const decadeIndex = this.decades.findIndex(decade => year.year >= decade.start && year.year <= decade.end)

              if (decadeIndex !== -1) {
                activeDecadeIndex = decadeIndex
              }
            }
          }
        }
      })

      if (activeDecadeIndex !== null && this.activeIndex !== activeDecadeIndex) {
        this.activeIndex = activeDecadeIndex
      }
    },
    selectDecade(decade) {
      const container = this.$refs.timeline
      const yearElement = document.querySelector(`#year-${this.years.filter(event => event.year >= decade.start && event.year <= decade.end)[0].year}`)

      if (yearElement) {
        container.scrollTo({
          top: yearElement.offsetTop - container.offsetTop - 10,
          behavior: 'smooth'
        })
      }
    },
    onScroll() {
      this.isActiveRange()
    },
    onResize() {
      this.width = window.innerWidth
    }
  }
}
</script>
